import PropTypes from 'prop-types'

const GanttBarQuantilePropType = PropTypes.arrayOf(PropTypes.number)

export default GanttBarQuantilePropType
